import Component from "@glimmer/component"
import type { Args as BodyArgs } from "cc-frontend/components/planner/modals/edit-annotation-body"
import styles from "./edit-annotation.module.css"

type ArgsToPassToBody = Omit<BodyArgs, "closeModal">
export interface Args extends ArgsToPassToBody {
  modalTitle: string
}

export default class EditAnnotationComponent extends Component<Args> {
  readonly styles = styles
}
